import {
  ChevronRight,
  Crosshair,
  Gamepad2,
  MoveHorizontal,
  Shield,
  Sparkles,
  Trophy,
  Zap,
} from "lucide-react";
import { Link } from "react-router-dom";

const abilities = [
  {
    icon: MoveHorizontal,
    title: "Mozgás és ugrás",
    body: "Haladj a romos városon át, ugord át a veszélyt, vagy guggolj a támadások alatt.",
    tone: "cyan",
  },
  {
    icon: Shield,
    title: "Védekezés",
    body: "Fordíts hátat a lövedékeknek, és védd ki őket a villámló tüskéiddel.",
    tone: "purple",
  },
  {
    icon: Sparkles,
    title: "Farok és dobbantás",
    body: "Söpörd félre a közel érkező tankokat, vagy rengetd meg alattuk az utat.",
    tone: "coral",
  },
  {
    icon: Zap,
    title: "Atomlézer",
    body: "Töltsd az energiát, majd lőj vibráló lézersugarat a tankokra és helikopterekre.",
    tone: "purple",
  },
];

const controls = [
  ["Mozgás", "A / D vagy nyilak"],
  ["Ugrás", "W / Space / fel"],
  ["Guggolás", "S / le"],
  ["Védekezés", "Q"],
  ["Farokcsapás", "Z"],
  ["Atomlézer", "X"],
  ["Dobbantás", "C"],
];

export function HomePage() {
  return (
    <>
      <section className="hero" aria-labelledby="hero-title">
        <div className="hero__image" aria-hidden="true" />
        <div className="hero__scrim" aria-hidden="true" />
        <img
          className="hero__character"
          src="/assets/zsombzilla-character.png"
          alt="A saját rajzból készült Zsombzilla karakter"
        />
        <div className="content-frame hero__content">
          <p className="eyebrow"><Crosshair aria-hidden="true" size={16} /> World 1-1: Tokyo Ruins</p>
          <h1 id="hero-title">Zsombzilla</h1>
          <p className="hero__lead">
            Egy saját készítésű kaiju-akciójáték, ahol tankok, helikopterek és romos városrészek
            állnak az utadba.
          </p>
          <div className="button-row">
            <Link className="button button--primary" to="/play">
              <Gamepad2 aria-hidden="true" size={20} /> Játék indítása
            </Link>
            <Link className="button button--secondary" to="/leaderboard">
              <Trophy aria-hidden="true" size={20} /> Toplista
            </Link>
          </div>
        </div>
      </section>

      <section className="mission-band" aria-labelledby="mission-title">
        <div className="content-frame mission-band__inner">
          <div>
            <p className="section-kicker">A küldetés</p>
            <h2 id="mission-title">Törd át Tokió védelmi vonalát</h2>
          </div>
          <p>
            Vezesd Zsombzillát a pálya végéig. Kerüld vagy semmisítsd meg az ellenséges járműveket,
            oszd be az atomenergiát, és maradj talpon, amíg eléred a romváros végét.
          </p>
        </div>
      </section>

      <section className="section content-frame" aria-labelledby="abilities-title">
        <div className="section-heading">
          <div>
            <p className="section-kicker">Harci képességek</p>
            <h2 id="abilities-title">Minden helyzetre van egy mozdulat</h2>
          </div>
          <span className="section-index">04 képesség</span>
        </div>
        <div className="ability-grid">
          {abilities.map(({ icon: Icon, title, body, tone }) => (
            <article className={`ability-card ability-card--${tone}`} key={title}>
              <Icon aria-hidden="true" size={28} />
              <h3>{title}</h3>
              <p>{body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="controls-section" aria-labelledby="controls-title">
        <div className="content-frame controls-section__layout">
          <div className="controls-section__intro">
            <p className="section-kicker">Irányítás</p>
            <h2 id="controls-title">Billentyűzeten és érintőképernyőn</h2>
            <p>
              Desktopon a billentyűzet, telefonon és tableten a játékba épített joystick és akciógombok
              vezérlik ugyanazokat a mozdulatokat.
            </p>
            <Link className="text-link" to="/play">
              Irány a játékmódok <ChevronRight aria-hidden="true" size={18} />
            </Link>
          </div>
          <dl className="control-list">
            {controls.map(([action, key]) => (
              <div key={action}>
                <dt>{action}</dt>
                <dd>{key}</dd>
              </div>
            ))}
          </dl>
        </div>
      </section>

      <section className="final-cta" aria-labelledby="cta-title">
        <div className="content-frame final-cta__inner">
          <div>
            <p className="section-kicker">Készen állsz?</p>
            <h2 id="cta-title">Indulhat a tombolás</h2>
          </div>
          <Link className="button button--primary" to="/play">
            <Gamepad2 aria-hidden="true" size={20} /> Játék indítása
          </Link>
        </div>
      </section>
    </>
  );
}
